import React from 'react';
import { Hero } from '../components/Hero';
import { Logos } from '../components/Logos';
import { Problem } from '../components/Problem';
import { CastingCalls } from '../components/CastingCalls';
import { RosterDatabase } from '../components/RosterDatabase';
import { Audiences } from '../components/Audiences';
import { ProductWorkflow } from '../components/ProductWorkflow';
import { Moat } from '../components/Moat';
import { CTA } from '../components/CTA';
import { InfluencerHub, CapterraReviews, Newsletter, ComingSoon } from '../components/HomeExtras';
import { Testimonials, BRAND_TESTIMONIALS } from '../components/Testimonials';
export const Home = () => {
  return <>
      <Hero data-id="element-1858" />
      <Logos data-id="element-1859" />
      <Problem data-id="element-1860" />
      <CastingCalls data-id="element-1861" />
      <RosterDatabase data-id="element-1862" />
      <Audiences data-id="element-1863" />
      <ProductWorkflow data-id="element-1864" />
      <Moat data-id="element-1865" />
      <Testimonials title="Loved by top brands and agencies" items={BRAND_TESTIMONIALS} data-id="element-1866" />
      <InfluencerHub data-id="element-1867" />
      <CapterraReviews data-id="element-1868" />
      <ComingSoon data-id="element-1869" />
      <CTA data-id="element-1870" />
      <Newsletter data-id="element-1871" />
    </>;
};